module.exports = __webpack_public_path__ + "static/media/sample_lmapprovedsob.c252e437.csv";